import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';

export const enum PageRoutes {
  DASHBOARD = 'dashboard',
  CLIENTS = 'clients',
  CLIENT_PROFILE = `dashboard/clients`,
  CLIENT_AGENDA = `dashboard/agenda`,
  SETTINGS = 'settings',
  APPOINTMENTS = 'appointments',
  AGENDA = 'agenda',
  REPORTS = 'report',
  LOGIN = 'login',
  REGISTER = 'register',
  HELP = 'help',
  SUPPORT = 'support',
  SUBSCRIPTION = 'subscription',
}

const routes: Routes = [
  { path: '', redirectTo: `/${PageRoutes.DASHBOARD}`, pathMatch: 'full' },
  {
    path: PageRoutes.LOGIN,
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: PageRoutes.REGISTER,
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: PageRoutes.DASHBOARD,
    loadChildren: () => import('./main/main.module').then( m => m.MainPageModule),
    canActivate: [AuthGuard]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
